/* eslint-disable react/jsx-pascal-case */
import React, { useState } from "react";
import profile from "../../assets/uicon.png";
import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import "../../css/homepage.css";
import Sign_modal from "../sign_modal";

const ViewcompanyItems = ({ item, values }) => {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  return (
    <div>
      <div className="bg-[#434242] text-white py-2 my-1 text-xs rounded-sm px-4 grid grid-cols-6 leftboxes">
        <div className="col-span-2 lg:col-span-1">
          {item?.logo ? (
            <>
              <img
                src={item?.logo}
                alt="profile"
                className="w-11 h-11 rounded-sm"
              />
            </>
          ) : (
            <img src={profile} alt="profile" className="w-11 h-11 rounded-sm" />
          )}
        </div>
        <p className="lg:col-span-1 truncate self-center col-span-2">
          {item?.company}
        </p>
        <p className="col-span-1 truncate self-center hidden lg:block">
          {item?.role}
        </p>
        <p className="col-span-1 truncate self-center hidden lg:block">
          {item?.startDate}
        </p>
        <button
          onClick={() => setShowMyModal(true)}
          className="lg:col-span-1 col-span-2 truncate self-center rounded-xl bg-transparent cursor-pointer hover:bg-slate-600"
        >
          Request Advance
        </button>
        <div className="col-span-1 hidden lg:flex justify-end self-center">
          <EllipsisVerticalIcon color="#ffff" className="h-6" />
        </div>
        <Sign_modal
          type={false}
          onClose={handleOnClose}
          visible={showMyModal}
          companies={item}
          values={values}
        />
      </div>
    </div>
  );
};

export default ViewcompanyItems;
